import React, { useContext } from 'react';
import EDPanel from '../../../../../BaseComponents/Panel/EDPanel';
import { getRutinPanelFullHeight } from '../../Const/Rutiner';
import { RutinSettingsContext } from '../RutinAvailabilityContext/RutinAvailabilityContext';
import { VisningsTypContext } from '../BusinessCollectionComponents/VisningsTypContext/VisningsTypContext';

export interface IProps {
  children: React.ReactNode;
  noTopMargin?: boolean;
  smallScreen?: boolean;
}

/**
Standardpanel för rutiner
*/
const StandardRutinMasterDetailPanel = (props: IProps) => {
  const rutinSettingsContext = useContext(RutinSettingsContext);
  const { visningsTyp, showDetailsRight } = useContext(VisningsTypContext);

  const rutinPanelFullheight = getRutinPanelFullHeight(
    rutinSettingsContext.activeRoutine?.routine.rutinKod
  );

  return (
    <EDPanel
      cardStyle
      cardContainerStyle={
        visningsTyp === 'kort' || visningsTyp === 'bisattningStart'
      }
      smallMargins={props.noTopMargin}
      small={props.smallScreen}
      noBottomMargin={showDetailsRight}
      allowHorzScroll={rutinPanelFullheight}
      contentPadding="none"
      flex
      elevation={showDetailsRight ? 0 : 2}
      dataTest="Rutinpanel"
      testId={`Rutinpanel-${rutinSettingsContext.activeRoutine?.routine.benamning}`}
      /* Pass null intentionally so EDPanel does not set an inline width. */
      width={null}
    >
      {props.children}
    </EDPanel>
  );
};

export default StandardRutinMasterDetailPanel;
